import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const MissionRewardTypes = Object.freeze({
  FREEBETS: 'FREEBETS',
});
export type MissionRewardType = ObjectValuesUnionType<typeof MissionRewardTypes>;

export type MissionReward = {
  rewardType: MissionRewardType;
  rewardParams: {
    amount: number;
    displayValue?: number;
  } | null;
};

export const MissionOperationTypes = Object.freeze({
  MISSION: 'MISSION',
  OTHER: 'OTHER',
});

export type MissionOperationType = ObjectValuesUnionType<typeof MissionOperationTypes>;

export type MissionId = number;

export type MissionFormatRule = {
  title: string;
  rules: string[];
};

export type MissionState = {
  missionId: MissionId;
  startDate: number;
  endDate: number;
  imageUrl: string | null;
  logoUrl: string | null;
  operationType: MissionOperationType;
  optInEnabled: boolean;
  showTimer: boolean;
  minPlacedAmount?: number | null;
  minBetOdds?: number | null;
  achievementIds: Array<number>;
  title: string;
  description: string;
  redirectUrl: string | null;
  rulesUrl: string;
  reward?: MissionReward | null;
  colors?: Array<string> | null;
  rules?: Array<string> | null;
  formatRules?: Array<MissionFormatRule> | null;
  sportIds: Array<number>;
  categoryIds: Array<number>;
  tournamentIds: Array<number>;
  matchIds: Array<number>;
  isArchived?: boolean;
};
